<div class="body audit-body">
    
    <div class="section" *ngIf="(createdItems$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">router</mat-icon>
            <span class="text">Neue Vorgangsartikel</span>
            <span class="counter">{{(createdItems$|async)?.length}}</span>

        </div>

        <div class="entry" *ngFor="let item of (createdItems$|async)">

            {{item.itemproduct|product|async}}

        </div>

    </div>

    <div class="section" *ngIf="(updatedItems$|async)?.length > 0">

        <div class="headline">
            
            <mat-icon class="icon">router</mat-icon>
            <span class="text">Geänderte Vorgangsartikel</span>
            <span class="counter">{{(updatedItems$|async)?.length}}</span>

        </div>

        <div class="entry" *ngFor="let item of (updatedItems$|async)">

            {{item.itemproduct|product|async}}

        </div>

    </div>

</div>